import { render } from "./ComprasCreate.vue?vue&type=template&id=1f1fdcc8&scoped=true"
import script from "./ComprasCreate.vue?vue&type=script&lang=js"
export * from "./ComprasCreate.vue?vue&type=script&lang=js"

import "./ComprasCreate.vue?vue&type=style&index=0&id=1f1fdcc8&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1fdcc8"]])

export default __exports__